import { render, staticRenderFns } from "./SentenceStatusIcon.vue?vue&type=template&id=1b8c1ff4"
import script from "./SentenceStatusIcon.vue?vue&type=script&lang=js"
export * from "./SentenceStatusIcon.vue?vue&type=script&lang=js"
import style0 from "./SentenceStatusIcon.vue?vue&type=style&index=0&id=1b8c1ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports